import Home from '@mui/icons-material/Home';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function HomeIcon(props: FixMe) {
  return <Home {...props} />;
}

export default HomeIcon;
